/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TenantService } from '@src/app/shared/tenant.service';
import { AbstractObject, uuid } from '@src/app/model/abstract-object';

export class BankOption {
    id: string;
    name: string;
    bic: string;
    transaction_total_days: string; // numeric value as string...
    countries: string[];
    logo: string;
}

export class GoCardlessAccount {
    id: uuid;
    created: string;
    last_accessed: string;
    iban: string;
    institution_id: uuid;
    status: string;
    owner_name: string;
    matched: boolean;
}

export class GoCardlessAccess extends AbstractObject {
    created: string;
    gocInstitutionId: uuid;
    bankName: string;
    status: string;
    accounts: GoCardlessAccount[];
    gocLink: string;
}

@Injectable({
    providedIn: 'root'
})
export class GoCardlessOpenBankingService {
    protected http = inject(HttpClient);

    protected get baseUrl() : string {
        return TenantService.ajaxPath + 'openbank';
    }

    requestAccess(bo: BankOption) {
        return this.http.post<GoCardlessAccess>(this.baseUrl + '/access', { bankId: bo.id, bankName: bo.name })
    }

    getBanks() {
        return this.http.get<BankOption[]>(this.baseUrl + '/banks');
    }

    getAccesses() {
        return this.http.get<GoCardlessAccess[]>(this.baseUrl + '/access');
    }

    removeAccess(goca: GoCardlessAccess) {
        return this.http.delete<GoCardlessAccess[]>(this.baseUrl + '/access/' + goca.id);
    }

    testAccess(goca: GoCardlessAccess){
        return this.http.post<{ accounts: number, description: string }>(this.baseUrl + '/test/' + goca.id, {});
    }

}
